export default {"src":"/_next/static/media/VideoGif1.90feaeb6.gif","height":737,"width":800,"blurWidth":0,"blurHeight":0};